import * as Actions from 'actions/base-station';
import { GetStatusParam, StationStatusFlat } from 'models/base-station-status';
import { Repository } from 'utils/repository';

export type State = Repository<StationStatusFlat, GetStatusParam, 'stationId'>;
const initState: State = Repository.create('stationId');

export const reducer = (state: State = initState, action: Actions.Action): State => {
  switch (action.type) {
    case Actions.BASE_STATION_STATUS_DATA_LOAD_START:
      return state.setFetched(action.params, false);
    case Actions.BASE_STATION_STATUS_DATA_LOAD_FAILURE:
      return state.setFetched(action.params, true);
    case Actions.BASE_STATION_STATUS_DATA_LOAD_SUCCESS:
      return state
        .setFetched(action.params, true)
        .setData(action.params, action.data);

    default:
      return state;
  }
};
